var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    { staticClass: "list" },
    [
      _vm._l(_vm.chats, function (chat) {
        return _vm.chats.length
          ? _c(
              "li",
              { staticClass: "listItemStyle" },
              [_c("chat-item", { attrs: { chat: chat, isCommonChats: true } })],
              1
            )
          : _vm._e()
      }),
      !_vm.chats.length
        ? _c("li", { staticClass: "itemNoChats" }, [
            _vm._v(_vm._s(_vm.$t("no-chats"))),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }